import { AbstractControl, Validators } from '@angular/forms';

const EMAIL_REGEXP_PATTERN = new RegExp("^([a-zA-Z0-9]+)+[\._-]?[a-zA-Z0-9']+@[a-zA-Z0-9-_]+[\._-]?[a-zA-Z0-9]+([.]+[a-zA-Z]{2,3}){1,2}$");

export const emailPattern = (control: AbstractControl): object | null => {
    const emailString: string = control.value;
    let validatorObj;
    if (control.errors) {
        if (control.errors.required && control.errors.email) {
            validatorObj = (EMAIL_REGEXP_PATTERN.test(emailString)) ? null : { email: true };
        }
        else if (control.errors.email && emailString == "") {
            validatorObj = null;
        }
        else if (control.errors.email && emailString != "") {
            validatorObj = (EMAIL_REGEXP_PATTERN.test(emailString)) ? null : { email: true };
        }
    }
    return validatorObj;
}

// export const emailAsyncPattern = (): AsyncValidatorFn => {
//     return (control: AbstractControl): Observable<ValidationErrors | null> => {
//         return of(control.value).pipe(
//             tap((emailString) => {
//                 if (!control.value && control?.errors?.required) {
//                     return of({ required: true });
//                 }
//                 else if (!EMAIL_REGEXP_PATTERN.test(emailString)) {
//                     return of({ email: true });
//                 }
//                 else {
//                     return of(null);
//                 }
//             })
//         )
//     }
// }

export const emailCCPattern = (control: AbstractControl): object | null => {
    const emailString: any = control.value ? control.value?.split(',')?.length > 0 ? control.value?.split(',') : control.value : control.value;
    let findArr = [];
    let validateObj;
    if (typeof emailString == 'object' && emailString) {
        validateObj = (emailString
            ?.map(email => Validators.email(<AbstractControl>{ value: email }))
            ?.find(val => val !== null) === undefined);
        if (!validateObj) {
            return { email: true };
        }
        if (!emailString[control.value?.split(',')?.length - 1]) {
            return { email: true };
        }
        emailString?.forEach(el => {
            if (!EMAIL_REGEXP_PATTERN.test(el)) {
                findArr?.push(true);
            }
        });
        if (findArr?.length) {
            return { email: 'true' };
        }
    }
    return validateObj;
}